import { restApi } from '../../api/restApiSlice';
import { CfFlowStatus } from './cloudflareFlowApi';

export type CfPropagationCheckRefusal =
  | 'token_invalid'
  | 'not_checkable'
  | 'manual_cleanup_required'
  | 'already_running'
  | 'not_startable'
  | 'beta_closed';

export type CfNameserverDelegation = 'cloudflare' | 'partial' | 'other' | 'unknown';

export type CfPropagationCheckResponse = {
  started: boolean;
  status: CfFlowStatus;
  refusal: CfPropagationCheckRefusal | null;
  lastCheckedAt: string | null;
  unavailable: boolean;
  nameserverDelegation: CfNameserverDelegation | null;
};

const cloudflarePropagationCheckApi = restApi.injectEndpoints({
  endpoints: (builder) => ({
    checkCfPropagation: builder.mutation<CfPropagationCheckResponse, { domain: string }>({
      query: ({ domain }) => ({
        url: '/v3/cloudflare/propagation/checks',
        method: 'POST',
        params: { domain },
      }),
    }),
  }),
});

export { cloudflarePropagationCheckApi };
export const { useCheckCfPropagationMutation } = cloudflarePropagationCheckApi;
